module.exports = __webpack_public_path__ + "tenant-connect.0928e959bfe982a417baff2e22e56cbe.hashedasset.svg";